import { Inject, Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { BaseController } from '@shared/src/controllers/base.controller';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs';
import { FilterTruckingShipmentPackageDto } from '@shared/src/dtos/trucking/FilterTruckingShipmentPackageDto';
import { TruckingShipmentPackageCtrlDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageCtrlDto';
import { FilterTruckingRouteDto } from '@shared/src/dtos/trucking/FilterTruckingRouteDto';
import { TruckingRouteCtrlDto } from '@shared/src/dtos/trucking/TruckingRouteCtrlDto';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingRouteDto } from '@shared/src/dtos/trucking/TruckingRouteDto';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { TruckingShipmentDto } from '@shared/src/dtos/trucking/TruckingShipmentDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingPackageDetailDto } from '@shared/src/dtos/trucking/TruckingPackageDetailDto';

@Injectable({
    providedIn: 'root',
})
export class TruckingController extends BaseController {
    private base = '/trucking'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router);
    }

    public refreshShipmentList$: EventEmitter<boolean> = new EventEmitter();
    public refreshRouteList$: EventEmitter<boolean> = new EventEmitter();
    public shipmentPackageChanged$: EventEmitter<TruckingShipmentPackageDto> = new EventEmitter();
    public routeChanged$: EventEmitter<number> = new EventEmitter();

    public getTruckingShipments(filter: FilterTruckingShipmentPackageDto): Observable<TruckingShipmentPackageCtrlDto> {
        return this.post(this.base + "/shipments", filter, "getTruckingShipments");
    }

    public getTruckingPackages(filter: FilterTruckingShipmentPackageDto): Observable<TruckingShipmentPackageCtrlDto> {
        return this.post(this.base + "/packages", filter, "getTruckingPackages");
    }

    public getTruckingRoutes(filter: FilterTruckingRouteDto): Observable<TruckingRouteCtrlDto> {
        return this.post(this.base + "/routes", filter, "getTruckingRoutes");
    }

    public getTruckingShipmentsExactKey(filter: FilterTruckingShipmentPackageDto): Observable<TruckingShipmentPackageCtrlDto> {
        return this.post(this.base + "/shipments/exactkey", filter, "getTruckingShipmentsExactKey");
    }
    
    public getTruckingPackagesExactKey(filter: FilterTruckingShipmentPackageDto): Observable<TruckingShipmentPackageCtrlDto> {
        return this.post(this.base + "/packages/exactkey", filter, "getTruckingPackagesExactKey");
    }

    public getTruckingRoutesExactKey(filter: FilterTruckingRouteDto): Observable<TruckingRouteCtrlDto> {
        return this.post(this.base + "/routes/exactkey", filter, "getTruckingRoutes");
    }

    public getTruckingShipment(shipmentId: number, filterKeys: String[]): Observable<TruckingShipmentDto> {
        return this.post(this.base + "/shipment/" + shipmentId, filterKeys, "getTruckingRoutes");
    }
    
    public getTruckingRouteExpand(routeId: number): Observable<TruckingRouteExpandDto> {
        return this.get(this.base + "/route/" + routeId);
    }

    public getTruckingPackageDetail(packageId: number): Observable<TruckingPackageDetailDto> {
        return this.get(this.base + "/package/detail/" + packageId);
    }
    
    public createEmptyRoute(): Observable<TruckingRouteDto> {
        return this.getBusy(this.base + "/createemptyroute");
    }

    public executeAction(value: TruckingRouteExecuteActionDto): Observable<boolean> {
        return this.postBusy(this.base + "/executeaction", value, "executeAction" + value.action);
    }

}
